import React, { createContext, useContext, useMemo, useState } from 'react';

const CategoryAndLevelContext = createContext();
const initialCategoryLevel = {
	categoryName: '',
	level: 1,
	breadcrumbs: ['All'],
};

export const CategoryAndLevelProvider = ({ children }) => {
	const [categoryAndLevel, setCategoryLevel] = useState({
		...initialCategoryLevel,
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleColumnClick = (e, operation) => {
		if (operation === 'drilldown' && categoryAndLevel.level < 4) {
			setCategoryLevel(prev => ({
				...prev,
				categoryName: e,
				level: prev.level + 1,
				breadcrumbs: [...prev.breadcrumbs, e].slice(0, 4),
			}));
		} else {
			if (
				categoryAndLevel.categoryName !== 'L1' &&
				categoryAndLevel.categoryName !== e[0]
			) {
				setCategoryLevel(prev => ({
					...prev,
					categoryName: e[0],
					level: e[1],
					breadcrumbs: [...prev.breadcrumbs].slice(0, e[1]),
				}));
			}
		}
	};
	const memoizedValue = useMemo(
		() => {
			return {
				categoryAndLevel,
				handleColumnClick,
			};
		},
		[categoryAndLevel, handleColumnClick]
	);
	return (
		<CategoryAndLevelContext.Provider value={memoizedValue}>
			{children}
		</CategoryAndLevelContext.Provider>
	);
};

export const useCategoryAndLevelContext = () =>
	useContext(CategoryAndLevelContext);
